import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

import { OfflineBanner } from '@/components/feedback/OfflineBanner'
import { PageLoader } from '@/components/feedback/PageLoader'
import { BrandLockup } from '@/components/layout/BrandLockup'
import { PageHeader } from '@/components/layout/PageHeader'

import styles from './PlatformShell.module.css'

/**
 * The platform admin's frame. It has no Standort, so none of the workspace's
 * tenant chrome: no navigation, no "Kunde erstellen", no Standort switcher.
 * `PageHeader` brings the title and the sign-out; its switcher and invite
 * button stay hidden for a session at no Standort.
 */
export function PlatformShell() {
  return (
    <div className={styles.shell}>
      <OfflineBanner />

      <header className={styles.bar}>
        <BrandLockup variant="inverse" mark="dots" tenant="Plattformverwaltung" />
      </header>

      <PageHeader />

      <div className={styles.scroll}>
        <main className={styles.main}>
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  )
}
